<template>
  <!-- Add Role -->
  <div
    class="modal custom-modal fade custom-modal-two modal-padding"
    id="add_company_role"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header header-border justify-content-between p-0">
          <h5 class="modal-title">Add Role</h5>
          <button
            type="button"
             ref="Close"
            class="btn-close position-static"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="add-info-fieldset">
                <div class="contact-input-set">
                  <div class="row">
                    
                    <div class="col-md-6">
                      <div class="input-block mb-3">
                        <label class="col-form-label"
                          >Role <span class="text-danger"> *</span></label
                        >
                        <input class="form-control" type="text" v-model="roleName"/>
                      </div>
                    </div>
                   <div class="col-lg-12 text-end form-wizard-button">
                      <button
                        class="btn btn-primary wizard-next-btn"
                        type="button" data-bs-dismiss="modal"
                        @click="addRole"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Role -->
    <!-- Edit Role Modal -->
  <div class="modal custom-modal fade" id="edit_company_role" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Role</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateRole">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Role<span class="text-danger">*</span></label
              >
              <input class="form-control" v-model="roleName" type="text" />
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="submit" data-bs-dismiss="modal">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Role Modal -->

  <!-- Delete Role Modal -->
  <div class="modal custom-modal fade" id="delete_company_role" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Role</h3>
            <p>Are you sure want to delete {{roleName}} role?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary continue-btn" @click="deleteRole" data-bs-dismiss="modal"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Role Modal -->
</template>

<style scoped>
#map{
    width: 100%;
    height: 50vh;
}
</style>

<script>
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../config";
import { ref } from 'vue';

// import 'leaflet-control-geocoder/dist/Control.Geocoder.js';  // For search functionality
// import "leaflet-control-geocoder/dist/Control.Geocoder.css";

export default {
    data(){
      return {
        map: null,
        roleName:'',
        marker:null,
        id:null,
        // searchQuery,
        // searchAddress,
      };
    },

    mounted() {
    },

    methods: {

      editRole(data){

        this.roleName = data.name,
        this.id = data.id

      },
      
      async addRole() {
        // this.loader = true;
      
        await axios.post(`${VUE_APP_API_BASE_URL}/company-role/add`,{
            name: this.roleName,
          })
          .then((response) => {
            if (response.data.status === true) {
              this.$toast.success(response.data.message);
              this.$emit("roleModal");
              // this.loader = false;
            } else {
              this.$toast.error(response.data.message || response.data.errors);
            }
          }).catch(function (error) {
            console.log(error);
          });
      },

      async updateRole(){
        await axios.post(`${VUE_APP_API_BASE_URL}/company-role/update`,{
          id:this.id,
          name:this.roleName
        }).then((response)=>{
          if(response.data.status === true){
            this.$emit("roleModal");
            this.$toast.success(response.data.message);
          }else {
              this.$toast.error(response.data.message || response.data.errors);
            }
        }).catch(function (error){
          console.log('error ',error);
        });
      },

      async deleteRole(){
        await axios.post(`${VUE_APP_API_BASE_URL}/company-role/delete`,{
            id:this.id,
          }).then((response)=>{
          if(response.data.status === true){
            this.$emit("roleModal");
            this.$toast.success(response.data.message);
          }else {
                this.$toast.error(response.data.message || response.data.errors);
              }
        }).catch(function (error){
          console.log(error);
        });
      }
    }
};
</script>
